import React from 'react';
import { GoogleAuthProvider, signInWithPopup, signInWithRedirect } from 'firebase/auth';
import { auth } from 'src/firebase/client-app';
import { useAppDispatch, useResponsive } from 'src/hooks';
import { signIn } from 'src/store/user/actions';

import { State as AuthState } from './state';

type Props = {
  action: AuthState['authType'];
  onSuccess: () => unknown;
};
const GoogleProvider: React.FC<Props> = ({ action, onSuccess }) => {
  const appDispatch = useAppDispatch();
  const [isDesktop] = useResponsive('DESKTOP');

  React.useEffect(() => {
    const init = async () => {
      if (isDesktop === undefined) return;

      try {
        const provider = new GoogleAuthProvider();

        if (!isDesktop) window.localStorage.setItem('isCheckRedirectSignInRequired', 'true');
        await auth.signOut();

        // ENV === 'local' added to avoid local issue with 'third party app'
        const result =
          isDesktop || process.env.ENV === 'local'
            ? await signInWithPopup(auth, provider)
            : await signInWithRedirect(auth, provider);

        const { user } = result;

        if (!user.email || !user.uid) {
          throw new Error('User email or uid is not provided');
        }

        const signInResult = await appDispatch(
          signIn({
            // provider: 'google',
            email: user.email,
            avatar: user.photoURL ?? '',
            name: user.displayName ?? '',
          })
        ).unwrap();

        if (signInResult.success) {
          onSuccess();
        } else {
          console.info('signInResultError', signInResult);
        }
      } catch (error) {
        console.log('Unable to get user data', (error as Error).message || error);
      }
    };

    init();
  }, [appDispatch, isDesktop]);

  return null;
};

export default GoogleProvider;
